import { Link } from "react-router-dom"

export default function ChargeCard({balance}) {
  return (
    <>
        <div className={`d-flex flex-row justify-content-between align-items-center fsSmall p-4`}>
            <div>
                <span className={`me-1 fw-semibold`}>
                    Balance:
                </span>
                <span>
                    ${balance}
                </span>
            </div>
            <div>
            <Link
                className='text-decoration-none text-primary fw-semibold' 
                to={'charge'}
            >
                Charge
            </Link> 
            </div>
        </div>
    </>
  )
}
